import { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import bottomDog from "../../assets/bottom_dog_compress.png";
import discordIcon from "../../assets/discord_icon.png";
import instagramIcon from "../../assets/instagram_icon.png";
import pininterestIcon from "../../assets/pinterest_icon.png";
import twitterIcon from "../../assets/twitter_icon.png";
import './SocialSection.css';

const SocialSection = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-slide');
        }
      },
      { threshold: 0.1 }
    );

    const headingElement = headingRef.current; // Copy the ref value to a variable

    if (headingElement) {
      observer.observe(headingElement);
    }

    return () => {
      if (headingElement) {
        observer.unobserve(headingElement);
      }
    };
  }, []);

  return (
    <div className='social_section' id='followUs'>
      <Container>
        <h1 ref={headingRef}>Follow Samurai Dogg</h1>

        <div className='social_section_icons'>
          <a rel="noreferrer" target='_blank' href='https://www.instagram.com/samuraidogg/'> <img src={instagramIcon} alt='' /></a>
          <a rel="noreferrer" target='_blank' href='https://x.com/samuraidoggxyz'> <img src={twitterIcon} alt='' /></a>
          <a rel="noreferrer" target='_blank' href='https://t.me/samuraidogg'> <img src={discordIcon} alt='' /></a>
          <a rel="noreferrer" target='_blank' href='https://www.pinterest.com/samuraidogg/'> <img src={pininterestIcon} alt='' /></a>
        </div>

        <Row className='align-items-center justify-content-center'>
          <Col md={6}>
            <div className='social_section_left'>
              <img src={bottomDog}
                alt="bottomDog"
                className='bottom_dog_img' />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SocialSection